import {User, Business, Team, TeamAssignment} from "@irati/types"

export function isGlobalAdmin(_business: Business, user: User) {
  return Boolean(user?.isGlobalAdmin)
}

export function isManagerOfTeam(team: Team, user: User) {
  const found = user?.teamAssignments?.find((t) => t.teamId === team.uuid)
  if (found) {
    // we only use one assignment level, manager or leader, same thing
    return found.assignment === TeamAssignment.Leader || found.assignment === TeamAssignment.Manager
  }

  return false
}

export function isLeaderOfTeam(team: Team, user: User) {
  return isManagerOfTeam(team, user)
}
